import { LeadStatus, LeadType, LeadOutcome } from "../types/LeadTypes";

export interface FilterOption {
  value: string;
  label: string;
  leadType?: LeadType;
}

export const getStatusOptions = (): FilterOption[] => [
  {
    value: "Call Answered",
    label: "Call Answered",
    leadType: "Call" as LeadType,
  },
  { value: "Call Missed", label: "Call Missed", leadType: "Call" as LeadType },
  {
    value: "Call Returned",
    label: "Call Returned",
    leadType: "Call" as LeadType,
  },
  {
    value: "Form Received",
    label: "Form Fill Received",
    leadType: "Form" as LeadType,
  },
  {
    value: "Form Replied",
    label: "Form Fill Responded",
    leadType: "Form" as LeadType,
  },
];

export const getOutcomeOptions = (): FilterOption[] => [
  { value: "Appointment Set", label: "Appointment Set" },
  { value: "Sale Won", label: "Sale Won" },
  { value: "Call Back Requested", label: "Call Back Requested" },
  { value: "Lead Will Call Back", label: "Lead Will Call Back" },
  { value: "Research / Price Shopping", label: "Research / Price Shopping" },
  { value: "Unknown", label: "Unknown" },
  { value: "Existing Customer", label: "Existing Customer" },
  {
    value: "Disqualified (spam/telemarketer)",
    label: "Disqualified (spam/telemarketer)",
  },
  {
    value: "Disqualified (wrong number)",
    label: "Disqualified (wrong number)",
  },
  {
    value: "Disqualified (out of service area)",
    label: "Disqualified (out of service area)",
  },
  {
    value: "Disqualified (wrong industry)",
    label: "Disqualified (wrong industry)",
  },
  {
    value: "Disqualified (looking for competitors)",
    label: "Disqualified (looking for competitors)",
  },
  {
    value: "Disqualified (not sales related)",
    label: "Disqualified (not sales related)",
  },
  {
    value: "Disqualified (spam/telemarketer)",
    label: "Disqualified (spam/telemarketer)",
  },
  { value: "Disqualified (wrong area)", label: "Disqualified (wrong area)" },
  {
    value: "Disqualified (wrong number)",
    label: "Disqualified (wrong number)",
  },
  {
    value: "Disqualified (employment inquiry)",
    label: "Disqualified (employment inquiry)",
  },
  { value: "Lost (competition)", label: "Lost (competition)" },
  { value: "Lost (language barrier)", label: "Lost (language barrier)" },
  { value: "Lost (price too high)", label: "Lost (price too high)" },
  { value: "Lost (job too small)", label: "Lost (job too small)" },
  {
    value: "Lost (service not provided)",
    label: "Lost (service not provided)",
  },
  { value: "Lost (service timeline)", label: "Lost (service timeline)" },
  { value: "Lost (unknown)", label: "Lost (unknown)" },
];

export const getTypeOptions = (): FilterOption[] => [
  { value: "Call", label: "Phone Call", leadType: "Call" as LeadType },
  { value: "Form", label: "Form Fill", leadType: "Form" as LeadType },
];

export const isQualifiedOutcome = (outcome: LeadOutcome | null): boolean => {
  if (!outcome) return false;
  // A qualified outcome is anything that doesn't start with "Disqualified"
  return !outcome.startsWith("Disqualified") && outcome !== "Existing Customer";
};

export const isDisqualifiedOutcome = (outcome: LeadOutcome | null): boolean => {
  if (!outcome) return false;
  // A disqualified outcome is anything that starts with "Disqualified" or is "Existing Customer"
  return outcome.startsWith("Disqualified") || outcome === "Existing Customer";
};
